import styled from '@emotion/styled'
import { small } from '@sphinx/components-styles/lib/design-tokens'
import * as React from 'react'

interface PaneProps {
  isVertical: boolean
  size?: number
  allowResize?: boolean
  primary?: boolean
  className?: string
  children?: React.ReactNode
}

const PaneStyle = styled.div`
  overflow: hidden;

  @media screen and (max-width: ${small.end}) {
    overflow: initial;
  }

  z-index: 1;
`

export const Pane: React.FC<PaneProps> = ({
  isVertical,
  size = 0,
  allowResize = true,
  children,
  primary: isPrimary = false,
  className,
}) => {
  const initialSize = {
    height: 'auto',
    width: 'auto',
  }

  const paneSizeStyle = isVertical
    ? { height: `${size}px` }
    : { width: `${size}px` }
  const paneStyle = isPrimary ? {} : paneSizeStyle

  return (
    <PaneStyle
      className={className}
      style={{
        ...(allowResize ? paneStyle : initialSize),
      }}
    >
      {children}
    </PaneStyle>
  )
}
